import { render, staticRenderFns } from "./ModelEditTool.vue?vue&type=template&id=2952e52c&scoped=true"
import script from "./ModelEditTool.vue?vue&type=script&lang=js"
export * from "./ModelEditTool.vue?vue&type=script&lang=js"
import style0 from "./ModelEditTool.vue?vue&type=style&index=0&id=2952e52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2952e52c",
  null
  
)

export default component.exports